export { default } from './Password.jsx';
